import { useCallback, useState } from 'react'

const DEFAULT_CENTER = { lat: 38.9013347, lng: -77.022491 }
const DEFAULT_ZOOM = 8

export function useMapPosition() {
    const [mapCenter, setMapCenter] = useState(DEFAULT_CENTER)
    const [mapZoom, setMapZoom] = useState(DEFAULT_ZOOM)
    const [mapReady, setMapReady] = useState(false)
    const [mapBounds, setMapBounds] = useState({})

    const updateMapPosition = useCallback(position => {
        if (!position) {
            return
        }
        console.dir(position)
        if (position.center) {
            const { lat, lng } = position.center
            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                setMapCenter(prev => {
                    if (Math.abs(prev.lat - lat) < 1e-6 && Math.abs(prev.lng - lng) < 1e-6) {
                        return prev
                    }
                    return { lat, lng }
                })
            }
        }
        if (Number.isFinite(position.zoom)) {
            setMapZoom(prev => {
                if (Math.abs(prev - position.zoom) < 1e-6) {
                    return prev
                }
                return position.zoom
            })
        }
        if (position.bounds) {
            console.log("setting mapBounds")
            console.dir(position.bounds)
            setMapBounds(position.bounds)
        }
    }, [])

    const handleMapReady = useCallback(
        position => {
            updateMapPosition(position)
            setMapReady(true)
        },
        [updateMapPosition],
    )

    const handleMapIdle = useCallback(
        position => {
            updateMapPosition(position)
        },
        [updateMapPosition],
    )

    return {
        mapCenter,
        mapZoom,
        mapReady,
        mapBounds,
        handleMapReady,
        handleMapIdle,
    }
}
